import { inject, Pipe, PipeTransform } from '@angular/core';
import { WorkDocument, WorkDocumenttypeIdentifierNameEnum } from '@work-frontend-monorepo/work-rest-api';
import { PrependServerToFileSrcPipe } from './prepend-server-to-file-src.pipe';

@Pipe({
  name: 'getItemProductimagePathFromDocuments',
  standalone: true,
})
export class GetItemProductimagePathFromDocuments implements PipeTransform {
  private prependServerToFileSrcPipe = inject(PrependServerToFileSrcPipe);

  transform(documents?: WorkDocument[]): string {
    try {
      const productimageDocument = documents?.find(
        (document) => document.documenttype?.identifierName === WorkDocumenttypeIdentifierNameEnum.Produktbild,
      );
      if (productimageDocument) {
        return this.prependServerToFileSrcPipe.transform(productimageDocument.fileSrcOptimized);
      }
    } catch (noProductimageFound) {
      // Nothing to do, since product image is not mandatory to have.
    }
    return 'assets/images/img-placeholder.webp';
  }
}
